import { Box, Typography } from '@mui/material';
import React from 'react';

import LinkList, { ListItemOrientation, ListItemType } from '../ui/LinkList';
import { useOnDataLoaded } from '../hooks/use-on-data-loaded';
import { baseUrls } from '../../utils/baseUrls.utils';
import { topicsOrCategories } from '../../utils/utils';

import { ROOT_CATEGORIES } from '../../gql/categories';
import { CategoryItemNode } from '../../shared/types';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';

export interface BrowseCategoryListProps {
    browsePage?: boolean;
    parentCategoryName?: string;
    categories?: {
        _id: string;
        name: string;
    }[];
    onDataLoaded?: () => void;
}

export const BrowseCategoryList = ({
    categories = [],
    parentCategoryName = '',
    browsePage = false,
    onDataLoaded,
}: BrowseCategoryListProps): JSX.Element => {
    const { categoryId } = useParams<{ categoryId?: string }>();
    const queryCategories = useQuery(ROOT_CATEGORIES, {
        fetchPolicy: 'network-only',
        variables: !browsePage
            ? {
                  id: categoryId,
              }
            : {},
        skip: !browsePage,
    });
    useOnDataLoaded(queryCategories.loading, onDataLoaded);

    if (queryCategories.loading) return <></>;

    const categoryList: CategoryItemNode[] = !browsePage
        ? categories
        : queryCategories.data?.rootCategories;

    //TODO uncomment this part of code once the categories page been ready
    // const url = !browsePage ? `categories/${categoryId}` : 'categories';

    if (!categoryList?.length) {
        return <></>;
    }

    return (
        <div>
            <div id={'article-page-category-browse'}>
                <Typography variant="h5">
                    {!browsePage
                        ? `More in ${parentCategoryName}`
                        : `Browse ${topicsOrCategories(true)}`}
                </Typography>
            </div>
            <Box sx={{ my: 2 }}>
                <LinkList
                    items={(categoryList || []).map((category) => ({
                        id: category._id,
                        name: category.name,
                        url: `${baseUrls.browse.main}/${category._id}`,
                    }))}
                    orientation={ListItemOrientation.Horizontal}
                    displayType={ListItemType.Chip}
                    chipVariant={'info'}
                />
            </Box>
            {/* //TODO uncomment this part of code once the categories page been ready */}
            {/*<div className={classes.linkWrapper}>*/}
            {/*	<Link*/}
            {/*		className={classes.link}*/}
            {/*		to={url}*/}
            {/*		//TODO remove this after the URL above been defined*/}
            {/*		onClick={(e) => e.preventDefault()}*/}

            {/*	>*/}
            {/*		See all categories*/}
            {/*		<ArrowsChevronRight className={classes.rightArrow}/>*/}
            {/*	</Link>*/}
            {/*</div>*/}
        </div>
    );
};

export default BrowseCategoryList;
